<template lang="pug">
div
  Form(:data="company", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useCompanyAdd from './useCompanyAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, company, isSubmitting } = useCompanyAdd()

    return {
      company,
      create,
      isSubmitting,
    }
  },
}
</script>
